import { useEffect } from "react"
import { useHistory } from "react-router-dom"
import { useSelector } from "react-redux"



export default function PaymentCompleted() {
    const user = useSelector(state => state.auth.user);
    const history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            if (user.user_role == 2) {
                window.location.href = "/dashboard";
            } else {
                window.location.href = "/dashboard/levels";
            }

        }, 2000);

    }, [])
    return (
        <div style={{ height: "100vh", width: "100%" }} className="d-flex justify-content-center align-items-center flex-column">
            <h5 className="color-text-green">Payment Completed</h5>
            <div className="color-text-grey">You will be redirected soon</div>
        </div>
    )
}
